import type { QuerySpec } from '@helios/powersync-client-core';

// ─── Row Types ───

export interface PatientVisitRow {
  id: string;
  org_id: string;
  clinic_id: string | null;
  patient_id: string;
  visit_date: string; // 'YYYY-MM-DD'
  status: string; // 'open' | 'closed'
  queue_id: string | null;
  appointment_id: string | null;
  visited_at: string | null;
  reason: string | null;
  started_at: string | null;
  ended_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  updated_by: string | null;
}

// ─── Queries ───

/**
 * Find an open visit for a patient on a specific date.
 * Used by ensureVisitThenCreateEncounter to decide whether to reuse or create.
 */
export function qOpenVisitForPatientOnDate(
  patientId: string,
  visitDate: string,
): QuerySpec<[string, string, string]> {
  return {
    key: ['patient_visits', 'open', patientId, visitDate] as const,
    sql: `SELECT * FROM patient_visits
          WHERE patient_id = ? AND visit_date = ? AND status = ?
          ORDER BY started_at DESC
          LIMIT 1`,
    params: [patientId, visitDate, 'open'],
    watch: ['patient_visits'],
  };
}

/**
 * All visits for a patient, ordered by most recent first.
 */
export function qVisitsByPatient(patientId: string): QuerySpec<[string]> {
  return {
    key: ['patient_visits', 'by-patient', patientId] as const,
    sql: `SELECT * FROM patient_visits
          WHERE patient_id = ?
          ORDER BY visit_date DESC, started_at DESC`,
    params: [patientId],
    watch: ['patient_visits'],
  };
}
